// removed by extract-text-webpack-plugin
module.exports = {"electro":"_320mfetYst6oEKN2VE_quv","tg":"_15Y21oJeibzKffz1rfP12O","title":"_36utzVY1-xXy2YQq9pPk3K","subtitle":"RknzQpsFvLKau99HiPfOr","value":"_1SpKwpSOxQw81Ve-reMkqb","disabled":"_2sbxCzZr-Q4K1dWMwLsK2t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/ElMeterCell/style.css
// module id = 283
// module chunks = 0